module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00613.4028d635.jpg";